import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { storageService } from './storage.service';
import { authService } from '../services/auth.service'

class Request {
  client;

  constructor() {
    this.client = axios.create();
    this.client.interceptors.request.use(this.onPreRequest, this.onRequestFailure);
    this.client.interceptors.response.use(this.onRequestSuccess, this.onRequestFailure);
  }

  async onPreRequest(config: AxiosRequestConfig) {
    const token = await storageService.getAccessToken();

    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }

    return config;
  }

  onRequestSuccess(response: AxiosResponse) {
    return response;
  }

  onRequestFailure(error: any) {
    if (
      error.config &&
      [401, 403].includes(error.response?.status) &&
      !error.config.__isRetry
    ) {
      localStorage.clear();
      window.location.reload();
    }

    return Promise.reject(error);
  }
}

const request = new Request();
export const httpClient = request.client;

/**
 * HttpClient for react base on axios
 */
// export default httpClient;
